// import { ENV } from '~/enum/env';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { logger } from '~/classes/Logger';
import { ENV } from '~/enum/env';
import { paramURL } from '~/utils/common';
// Define fetch client with generics for type-safe responses
export function fetchClient(endpoint_1) {
    return __awaiter(this, arguments, void 0, function* (endpoint, _a = {}) {
        var { body, customDomain = ENV.ApiEntryPoint } = _a, customConfig = __rest(_a, ["body", "customDomain"]);
        const { token } = paramURL(); // Extract parameters if needed
        // Type-safe headers
        const headers = {
            'content-type': 'application/json',
            lng: 'vi',
        };
        if (token) {
            headers.token = `${token}`;
        }
        const config = Object.assign(Object.assign({ method: body ? 'POST' : 'GET' }, customConfig), { headers: Object.assign(Object.assign({}, headers), (customConfig.headers || {})) });
        if (body) {
            config.body = JSON.stringify(body);
        }
        try {
            let response = yield fetch(`${customDomain}${endpoint}`, config);
            if (response.status === 401) {
                logger.error('Unauthorized access - possibly invalid token');
                throw new Error('Unauthorized access');
            }
            if (response.ok) {
                // Type assertion to T
                return (yield response.json());
            }
            else {
                const errorMessage = yield response.text();
                throw new Error(errorMessage || `Error ${response.status}: ${response.statusText}`);
            }
        }
        catch (error) {
            // Rethrow with more context
            if (error instanceof Error) {
                throw new Error(`API call failed for endpoint ${endpoint}: ${error.message}`);
            }
            throw new Error(`API call failed for endpoint ${endpoint}`);
        }
    });
}
// Export additional typed helper methods for convenience
export const api = {
    get(endpoint, customConfig = {}) {
        return fetchClient(endpoint, Object.assign(Object.assign({}, customConfig), { method: 'GET' }));
    },
    post(endpoint, body, customConfig = {}) {
        return fetchClient(endpoint, Object.assign(Object.assign({}, customConfig), { body, method: 'POST' }));
    },
    put(endpoint, body, customConfig = {}) {
        return fetchClient(endpoint, Object.assign(Object.assign({}, customConfig), { body, method: 'PUT' }));
    },
    patch(endpoint, body, customConfig = {}) {
        return fetchClient(endpoint, Object.assign(Object.assign({}, customConfig), { body, method: 'PATCH' }));
    },
    delete(endpoint, customConfig = {}) {
        return fetchClient(endpoint, Object.assign(Object.assign({}, customConfig), { method: 'DELETE' }));
    },
};
